import React from "react";


const SpinnerSvg=(color:string)=>`data:image/svg+xml;charset=utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" >
<path fill="${color}" d="M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"/>
</svg>`

const PDFSvg = `data:image/svg+xml;charset=utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
<path fill="rgb(255, 0, 0)" d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"/>
</svg>`

const CloseSvg =`
data:image/svg+xml;charset=utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
</svg>
` 

const toggleOnSvg =`
data:image/svg+xml;charset=utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
<path fill="rgb(180 219 100)" d="M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"/></svg>
`

const toggleOffSvg =`
data:image/svg+xml;charset=utf8,
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
<path fill="rgb(180 180 180)" d="M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"/></svg>
`
type LoadingColorProps = {
    color?:string
}

export const Loading= (props:LoadingColorProps ) =>{ 
    return(
        <div className="loading">
            <img className="spinner" src={SpinnerSvg(props.color?props.color:"rgb(77, 105, 20)")}/>
        </div> 
    ) 
}

export const PDF= () =>{ 
    return(
        <img className="PDF-icon" src={PDFSvg}/>
    ) 
}

export const Close= () =>{ 
    return(
        <img className="close-icon" src={CloseSvg}/>
    ) 
}

export const ToggleOn= () =>{ 
    return(
        <img className="close-icon" src={toggleOnSvg}/>
    ) 
}

export const ToggleOff= () =>{ 
    return(
        <img className="close-icon" src={toggleOffSvg}/>
    ) 
}


